export const STEPS = ['start','job-brief','proof-bundle','capture','verify-passed','verify-failed','summary','job-closed'] as const
export type Step = typeof STEPS[number]
export const DEFAULT_STEP: Step = 'start'
export const isStep = (v: string | null | undefined): v is Step =>
  v != null && (STEPS as readonly string[]).includes(v)
